export default __webpack_public_path__ + "3d7dc1620dfa2e93061f0a3f5f29fe35.png";